
import { useEffect, useRef, useState } from 'react';
import { Autocomplete, IconArrowDropDown, IconArrowDropUp, Input, KEY_VALUES, MenuListItem } from 'cdk-radial';

export const ConfigureCMFDropdown = ({ locationOptions, onSelect, instanceId, selectedValue }) => {


  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState({ label: '', value: '' });

  useEffect(() => {
    setOptions(locationOptions);
  }, [locationOptions]);

  useEffect(() => {
    if (!selectedValue) {
      setSelectedOption({ label: '', value: '' });
      setInputValue('');
      return;
    }

    const preSelectedOption = locationOptions.find(
      option => option.value === selectedValue
    );

    if (preSelectedOption) {
      setSelectedOption(preSelectedOption);
      setInputValue(preSelectedOption.label);
    }
  }, [selectedValue, locationOptions]);

  const inputRef = useRef(null);
  const dimensionRef = useRef(null);

  // ----------- Input handlers and logic

  const handleOpen = () => {
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
  };

  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  const handleSelect = (option) => {
    setSelectedOption(option);
    setInputValue(option.label);
    setOptions(locationOptions);
    setIsOpen(false);
    inputRef.current?.focus();
    onSelect(option);
  };

  const clearSelection = (event) => {
    event.preventDefault();
    setInputValue('');
    setSelectedOption({ label: '', value: '' });
    setOptions(locationOptions);
    inputRef.current?.focus();
    onSelect(null);
  };

  // This function handles keyboard interaction when the input is focused
  const handleInputKeyDown = (event) => {
    if (event.key === KEY_VALUES.ENTER) {
      if (
        isOpen === true && // the menu is open
        inputValue.length > 0 && // there is something in the input
        options.length > 0 && // there are options available
        !options[0].isDisabled // the first option is not disabled
      ) {
        handleSelect(options[0]);
      }
    }
    if (event.key === KEY_VALUES.SPACE && inputValue === '') {
      toggleMenu();
      clearSelection(event);
    }
    if (event.key === KEY_VALUES.BACKSPACE && selectedOption.label !== '') {
      clearSelection(event);
    }
    if (event.key === KEY_VALUES.TAB && selectedOption.label === '') {
      setInputValue('');
      setOptions(locationOptions);
    }
  };

  // This search algorithm finds options based on substring match
  const filterOptions = (event) => {
    const inputText = event.target.value;
    setSelectedOption({ label: '', value: '' }); // clear the selected option on new filter
    setInputValue(inputText);
    setIsOpen(true);
    const textLength = inputText.length;

    const results = locationOptions.filter((opt) => {
      const optionLabel = opt?.label;
      const inputLower = inputText.toLowerCase();
      const labelLower = optionLabel.toLowerCase();

      return labelLower.includes(inputLower);
    });

    if (results.length > 0) {
      setOptions(results);
    } else {
      setOptions([{ label: 'No Results', isDisabled: true }]);
    }

    if (textLength === 0) {
      setOptions(locationOptions);
    }
  };

  return (
    <>
      <div style={{ width: '450px' }}>
        <Input
          autoComplete="off" // disables Browser dropdown list
          icon={isOpen ? <IconArrowDropUp /> : <IconArrowDropDown />}
          id={`autocomplete-dropdown-${instanceId}`}
          name={`autocomplete-dropdown-${instanceId}`}
          labelRef={dimensionRef}
          placeholder="CMF number or Store Name"
          onChange={filterOptions}
          ref={inputRef}
          value={inputValue}
          hasClearButton={false}
          onClick={toggleMenu}
          onKeyDown={handleInputKeyDown}
        />
      </div>
      <Autocomplete
        dimensionRef={dimensionRef}
        labelRef={inputRef}
        style={{ width: '450px', maxWidth: '450px' }}
        onClose={handleClose}
        onOpen={handleOpen}
        isOpen={isOpen}
        onUnselect={selectedOption.label === ''}
      >
        {options.map((option) => (
          <MenuListItem
            key={`$autocomplete-dropdown-${JSON.stringify(option)}`}
            isSelected={selectedOption.label === option.label}
            onClick={() => handleSelect(option)}
            isDisabled={option.isDisabled}
          >
            {option.label}
          </MenuListItem>
        ))}
      </Autocomplete>
    </>
  );
}
        